import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { format } from "date-fns";

import { loadHotels } from "../../redux/tasks/hotelsT";
import Sidebar from "../../components/Sidebar";
import TopBar from "../../components/TopBar";
import Table from "../../components/Table";
import Spinner from "../../components/Spinner";

const TableColumns = [
   {
      Header: "Hotel Name",
      accessor: "name",
   },
   {
      Header: "Contact No",
      accessor: "phone",
   },
   {
      Header: "Created On",
      accessor: "createdAt",
      Cell: ({ value }) => {
         return format(new Date(value), "MM-dd-yyyy");
      },
   },
];

const Hotels = ({ loading, hotels, loadHotels }) => {
   const navigate = useNavigate();
   const [numberOptions] = useState([5, 10, 15, 20, 25, 30]);
   const [globalFilter, setGlobalFilter] = useState("");

   useEffect(() => {
      loadHotels();
   }, [loadHotels]);

   const handleData = (index) => {
      const hotel = hotels[index];
      navigate("/hotel-details", { state: { hotel } });
   };

   return loading ? (
      <Spinner />
   ) : (
      <>
         <div className="flex flex-col h-screen">
            <TopBar />
            <div className="flex flex-1 overflow-hidden">
               <Sidebar />
               <main className="flex-1 p-4 overflow-y-auto">
                  <div className=" mx-auto">
                     <div className="flex flex-col gap-x-6 sm:flex-row sm:items-center sm:justify-end space-y-2 sm:space-y-0 sm:space-x-2 p-4">
                        <button
                           onClick={(e) => navigate("/regions")}
                           className="bg-sysRed hover:bg-red-600 font-semibold text-white py-2 px-4 rounded sm:order-2"
                        >
                           Manage Regions
                        </button>
                        <button
                           onClick={(e) => navigate("/hotel-add-new")}
                           className="bg-sysRed hover:bg-red-600 font-semibold text-white py-2 px-4 rounded sm:order-2"
                        >
                           + Add New Hotel
                        </button>

                        {/* Search Field */}
                        <div className="flex items-center border border-gray-300 rounded sm:order-1">
                           <input
                              type="text"
                              placeholder="Search"
                              className="p-2 w-full border-none outline-none"
                              value={globalFilter}
                              onChange={(e) => setGlobalFilter(e.target.value)}
                           />
                           <div className="p-2">
                              <FaSearch className="text-gray-500" />
                           </div>
                        </div>
                     </div>
                     {hotels?.length > 0 ? (
                        <Table
                           data={hotels}
                           columns={TableColumns}
                           numberOptions={numberOptions}
                           dataFun={handleData}
                           globalFilter={globalFilter}
                           setGlobalFilter={setGlobalFilter}
                        />
                     ) : (
                        <></>
                     )}
                  </div>
               </main>
            </div>
         </div>
      </>
   );
};

Hotels.propTypes = {
   loading: PropTypes.bool.isRequired,
   hotels: PropTypes.array,
   loadHotels: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
   loading: state.hotels.loading,
   hotels: state.hotels.hotels,
});

export default connect(mapStateToProps, { loadHotels })(Hotels);
